module.exports = __webpack_public_path__ + "extend.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/extend.png
// module id = 27
// module chunks = 0